import { Box, Button } from "@material-ui/core"
import { Desktop, Mobile, useIsDesktop } from "common/MediaQueries"
import {
  FooterAbout,
  FooterTalkToUsDesktop,
  FooterTalkToUsMobile,
  FooterToolBox,
} from "common/SiteLinks"
import { trackFooterClicks } from "common/analytics"
import NextImage from "common/bit/NextImage"
import NextLink from "common/bit/NextLink"
import { useGlobalContext } from "contexts/GlobalContext"
import Image from "next/image"
import styled from "styled-components"
import { HomePageContainer, StyledCol } from "theme/shared"
import FooterLinkList from "./FooterLinkList"
import SocialButtonsRow from "./SocialButtonsRow"

const StyledWrapper = styled(Box)`
  background-color: ${(p) => p.theme.colors.darkBlack};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding-top: 10px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-top: 80px;
  }
`

const StyledImageContainer = styled.div`
  aspect-ratio: 500/303;
  width: 100%;
  margin-bottom: 30px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 0px;
  }
`
const StyledFooterContainer = styled(HomePageContainer)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    align-items: center;
    justify-content: start;
  }
`
const StyledLinksWrapperRow = styled.div<{ $direction?: string }>`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  margin-bottom: 40px;
  width: 100%;
  gap: 30px;
  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 60px;
    width: min-content;
    margin-bottom: 0px;
    margin-bottom: 100px;
    &:last-of-type {
      width: 100%;
      flex-grow: 3;
      margin-bottom: 0px;
    }
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: ${(p) => p.$direction && p.$direction};
  }
`
const StyledDiv = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 100px;
  }
`
const StyledLinksBigWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  max-width: 400px;
  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 60px;
    display: flex;
    height: 100%;
    flex-direction: row;
    max-width: none;
  }
`
const StyledLogoMintContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
`

const StyledMintStrip = styled.div`
  width: 100%;
  height: 100%;
  /*  */
`

const StyledButton = styled(Button).attrs({
  color: "secondary",
  variant: "outlined",
})`
  max-width: 145px;
`

const Footer = () => {
  const { footerModelLinks } = useGlobalContext()
  const isDesktop = useIsDesktop()

  return (
    <>
      <StyledWrapper>
        <StyledFooterContainer>
          <Mobile>
            <StyledImageContainer>
              <NextImage
                image={{
                  imageUrl: "/img/MazdaVision.png",
                  alt: "מעבר לאתר mint",
                }}
              />
            </StyledImageContainer>
          </Mobile>
          <StyledLinksBigWrapper>
            <StyledDiv>
              <StyledLinksWrapperRow>
                <FooterLinkList
                  linkList={
                    isDesktop ? FooterTalkToUsDesktop : FooterTalkToUsMobile
                  }
                  title="דברו איתנו"
                  withIcons
                  extraButton={
                    <NextLink
                      href={`https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0`}
                      openInNewTab
                    >
                      <StyledButton
                        onClick={() => trackFooterClicks()}
                      >{`צ'אט עם נציג`}</StyledButton>
                    </NextLink>
                  }
                />
              </StyledLinksWrapperRow>
              <Desktop>
                <SocialButtonsRow />
              </Desktop>
            </StyledDiv>
            <StyledLinksWrapperRow>
              <FooterLinkList linkList={footerModelLinks} title="דגמי MAZDA" />
              <FooterLinkList
                linkList={[...FooterToolBox]}
                title="כלים נוספים"
              />
            </StyledLinksWrapperRow>
            <StyledLinksWrapperRow $direction="column">
              <StyledCol $fullWidth $notCenter $justify="space-between">
                <FooterLinkList linkList={FooterAbout} title="מידע נוסף" />
                <Desktop>
                  <StyledImageContainer>
                    <NextImage
                      image={{
                        imageUrl: "/img/MazdaVision.png",
                        alt: "מעבר לאתר mint",
                      }}
                    />
                  </StyledImageContainer>
                </Desktop>
              </StyledCol>
              <Mobile>
                <SocialButtonsRow />
              </Mobile>
            </StyledLinksWrapperRow>
          </StyledLinksBigWrapper>
        </StyledFooterContainer>
        <StyledMintStrip>
          <NextLink openInNewTab href="https://mintapp.co.il">
            <StyledLogoMintContainer>
              <Image
                width={151}
                height={31}
                objectFit="contain"
                src="/img/createdByMintMobile.png"
                alt="מעבר לאתר mint"
              />
            </StyledLogoMintContainer>
          </NextLink>
        </StyledMintStrip>
      </StyledWrapper>
    </>
  )
}

export default Footer
